import { render, staticRenderFns } from "./PerformanceAttributeSelection.vue?vue&type=template&id=520bf8bf&"
import script from "./PerformanceAttributeSelection.vue?vue&type=script&lang=js&"
export * from "./PerformanceAttributeSelection.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceAttributeSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports